export const nestedDatagridStyle = {
  "& .RaDatagrid-headerCell": {
    backgroundColor: "#f7de52eb",
    fontWeight: 700,
    fontSize: 16,
    color: "#000",
    zIndex: "1",
  },
  border: ".9px solid #d6d1d0a3",
  borderRadius: "5px",
  backgroundColor: "#d6d1d0a3",
};
